import { DEFAULT_BUTTON_PROPERTIES, BUTTON_SIZES } from '../constants/quickFilterButtonProperties';
import { createContext, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultFiltersBarContextValue = {
  advancedFiltersButtonState: undefined,
  associatedRecord: undefined,
  customPropertyNames: [],
  defaultButtonProperties: DEFAULT_BUTTON_PROPERTIES[BUTTON_SIZES.sm],
  defaultPropertyNames: [],
  enableAdvancedFiltersButton: false,
  enableAutoOpenInputPopovers: false,
  enableClearAdvancedFiltersButton: false,
  enableCustomFilters: false,
  enableReordering: false,
  forceShowClearQuickFilters: false,
  maxCustomQuickFilters: 5,
  newestCustomPropertyName: null,
  onClearAdvancedFilters: () => {},
  onClearQuickFilters: () => {},
  onCustomPropertyNamesChange: () => {},
  onOpenAdvancedFilters: () => {},
  prependCustomQuickFilters: false
};
const FiltersBarContext = /*#__PURE__*/createContext(defaultFiltersBarContextValue);
export const FiltersBarProvider = ({
  advancedFiltersButtonState,
  associatedRecord,
  children,
  customPropertyNames,
  defaultPropertyNames,
  enableAdvancedFiltersButton,
  enableAutoOpenInputPopovers,
  enableClearAdvancedFiltersButton,
  enableCustomFilters,
  enableReordering,
  forceShowClearQuickFilters,
  maxCustomQuickFilters,
  onClearAdvancedFilters,
  onClearQuickFilters,
  onCustomPropertyNamesChange,
  onOpenAdvancedFilters,
  prependCustomQuickFilters,
  size
}) => {
  const [newestCustomPropertyName, setNewestCustomPropertyName] = useState(null);
  const prevCustomPropertyNames = useRef(customPropertyNames);
  useEffect(() => {
    if (customPropertyNames.length > prevCustomPropertyNames.current.length) {
      const newPropertyNameIndex = prependCustomQuickFilters ? 0 : customPropertyNames.length - 1;
      const newPropertyName = customPropertyNames[newPropertyNameIndex];
      setNewestCustomPropertyName(newPropertyName);
      // reset newestCustomPropertyName since prevCustomPropertyNames gets updated
      setTimeout(() => {
        setNewestCustomPropertyName(null);
      }, 0);
    }
    prevCustomPropertyNames.current = customPropertyNames;
  }, [customPropertyNames, prependCustomQuickFilters]);
  const defaultButtonProperties = useMemo(() => DEFAULT_BUTTON_PROPERTIES[size], [size]);
  const contextValue = useMemo(() => {
    return {
      advancedFiltersButtonState,
      associatedRecord,
      customPropertyNames,
      defaultButtonProperties,
      defaultPropertyNames,
      enableAdvancedFiltersButton,
      enableAutoOpenInputPopovers,
      enableClearAdvancedFiltersButton,
      enableCustomFilters,
      enableReordering,
      forceShowClearQuickFilters,
      maxCustomQuickFilters,
      newestCustomPropertyName,
      onClearAdvancedFilters,
      onClearQuickFilters,
      onCustomPropertyNamesChange,
      onOpenAdvancedFilters,
      prependCustomQuickFilters
    };
  }, [advancedFiltersButtonState, associatedRecord, customPropertyNames, defaultButtonProperties, defaultPropertyNames, enableAdvancedFiltersButton, enableAutoOpenInputPopovers, enableClearAdvancedFiltersButton, enableCustomFilters, enableReordering, forceShowClearQuickFilters, maxCustomQuickFilters, newestCustomPropertyName, onClearAdvancedFilters, onClearQuickFilters, onCustomPropertyNamesChange, onOpenAdvancedFilters, prependCustomQuickFilters]);
  return /*#__PURE__*/_jsx(FiltersBarContext.Provider, {
    value: contextValue,
    children: children
  });
};
export const useFiltersBarContext = () => {
  return useContext(FiltersBarContext);
};
export default FiltersBarContext;